
import $ from 'jquery';
import MyLocalStorage from "../general/LocalStorage";

class NotifyForm {

	loading = false;

	constructor( popup ) {
		this.$popup = $( popup );
		this.$form  = this.$popup.find( 'form' );

		// Generate array of inputs.
		this.$inputs = [
			this.$form.find( '[type=submit]' ),
			this.$form.find( '[name="nia_privacypolicy"]' ),
			this.$form.find( '[name="email"]' ),
		];

		this.setup();
	}

	show_error = ( $el ) => {
		return $el.closest( '.input_row' ).addClass( 'has_error' ).addClass( 'row_has_message' ).removeAttr( 'data-notification' );
	};

	hide_error = ( $el ) => {
		return $el.closest( '.input_row' ).removeClass( 'has_error' ).removeClass( 'row_has_message' ).removeAttr( 'data-notification' );
	};

	setLoading = ( loading ) => {

		const formButton = this.$form.find( '[type=submit]' );

		if ( loading ) {
			this.$inputs[0].addClass( 'en_button--loading' ).attr( 'disabled', 'disabled' );
		} else {
			this.$inputs[0].removeClass( 'en_button--loading' ).removeAttr( 'disabled' );
		}

		this.loading = loading;
		return loading;
	};

	validateForm = ( data ) => {

		let isButtonDisabled = false;
		if ( data.policy === false ) {
			this.show_error( this.$inputs[1] );
			isButtonDisabled = true;
		} else {
			this.hide_error( this.$inputs[1] );
		}

		if ( data.email === false ) {
			this.show_error( this.$inputs[2] );
			isButtonDisabled = true;
		} else {
			this.hide_error( this.$inputs[2] );
		}

		// Set Button disabled.
		this.$inputs[0].prop( 'disabled', isButtonDisabled );
	};

	setup = () => {

		const self = this;

		const preFilledEmail =MyLocalStorage.getItem( 'RAF' );

		if ( preFilledEmail ) {
			$( '#niaa_34_email' ).val( preFilledEmail );
			$( '#nia_31_email' ).val( preFilledEmail );
		}

		// Validation Status.
		let data = {
			policy: false,
			email: this.$inputs[2].val() ? validEmail( this.$inputs[2].val() ) : false
		};

		// Handler for Privacy Policy Checkbox Field.
		this.$inputs[1].on( 'change', function() {
			data.policy = $( this ).is( ':checked' );
			self.validateForm( data );
		} );

		// Handler for E-Mail Input.
		this.$inputs[2].on( 'input', function() {
			data.email = validEmail( $( this ).val() );
			self.validateForm( data );
		} );

		// On submit.
		this.$form.on( 'submit', ( ev ) => {
			ev.preventDefault();
			self.submit();

			const $popups = $( '#popup_notifyifavailable, #popup_notifyifavailableagain' );
			let spec = 'null';

			$popups.each( function() {

				const popupId = $( this ).attr( 'id' );

				if ( 'popup_notifyifavailableagain' === popupId ) {
					spec = 'Notify Available again';
				} else if ( 'popup_notifyifavailable' === popupId ) {
					spec = 'Notify Available';
				}
			} );

			const event = $( 'title' ).text().trim();
			const email = this.$form.find( '[id]' ).val();

			window.TAO_KOE.Tracking.sendIdentifyEvent( spec, email, event );

		} );

		// When the quickview gets closed.
		this.$popup.on( 'popup_close.en',  () => {

			// Uncheck Privacy.
			self.$inputs[1].prop( 'checked', false );
			self.hide_error( this.$inputs[1] );
			data.policy = false;

			// Remove entered E-Mail Address.
			self.$inputs[2].val( '' );
			self.hide_error( this.$inputs[2] );
			data.email = false;
		} );
	}

	submit = () => {

		const self = this;

		// Do not trigger, if already loading.
		if ( this.loading ) {
			return;
		}
		this.setLoading( true );

		/*
        // Remove all Errors and add change handler.
        $(inputs).each(function () {
            self.hide_error( $( this ) );
            $(this).one("change", function () {
                self.hide_error( $( this ) );
            });
        });
        */

		return new Promise( ( resolve,reject ) => {

			$.ajax( {
				url: "/index.php?cl=acl-soon&fnc=notifyMe",
				type: "POST",
				data: self.$form.serialize(),
				complete: ( response ) => {

					var responseData = JSON.parse( response.responseText );

					if ( responseData.status !== false ) {
						MyLocalStorage.setItem( 'RAF', $( '#niaa_34_email' ).val() );
						MyLocalStorage.setItem( 'RAF', $( '#nia_31_email' ).val() );
					}
				}
			} )
				.done( resolve )
				.fail( ( xhr ) => {
					try {
						var data = JSON.parse( xhr.responseText )
						if ( data.status === false ) {
							return resolve();
						}
						if ( data.policy === false ) {
							self.show_error( self.$inputs[1] );
						}
						if ( data.email === false ) {
							self.show_error( self.$inputs[2] );
						}

						reject();
					} catch ( e ) {
						reject();
					}
				} )
				.always( () => self.setLoading( false ) );

		} ).then( () => {
			EN_KO.functions.close_popup();
			EN_KO.functions.open_popup( '#popup_notifyifavailable_done' );
		} )
	}

	static initForm = ( element ) => {
		const $element = $( element );
		const instance = $element.data( 'NotifyForm' ) || new NotifyForm( $element );
		$element.data( 'NotifyForm', instance );
		return instance;
	}
}


$( document ).ready( function() {

	// Load Forms for Notify Available and Again.
	const loadForm = function() {
		const $popups = $( '#popup_notifyifavailable, #popup_notifyifavailableagain' );

		$popups.each( function() {
			NotifyForm.initForm( this );

			// Open Modal if needed.
			const popupId = $( this ).attr( 'id' );
			if ( popupId === '#popup_notifyifavailableagain' && EN.Media.matches( null, 'desktop' ) ) {
				EN_KO.functions.open_popup( this );
			}
		} );
	}

	// Add Product ID on quickview open.
	$( document ).on( 'click', '[data-en-popup-target="popup_notifyifavailable"]', function() {

		const prodId = $( this ).data( 'prodId' );
		if ( prodId ) {
			$( '#popup_notifyifavailable form' ).find( 'input[name=aid]' ).val( prodId );
		}
	} )

	loadForm();
	$( document ).on( 'finished_change_variant', loadForm );
} );
